import React from 'react'
import { connect } from '@cerebral/react'
import { state, props, signal } from 'cerebral/tags'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import { formatDate } from 'react-day-picker/moment'
import 'react-day-picker/lib/style.css'
import Input from './input'
const format = 'YYYY-MM-DD'

const Picker = connect(
  {
    value: state`${props`path`}`,
    clearDate: signal`node.clearDate`,
    changeDate: signal`node.changeDate`,
    oppositeValue: state`${props`oppositePath`}`
  },
  ({ value, clearDate, changeDate, path, oppositeValue, before }) => {
    let disabledDays = {}
    if (oppositeValue) {
      if (before) {
        disabledDays = {
          after: new Date(oppositeValue)
        }
      } else {
        disabledDays = {
          before: new Date(oppositeValue)
        }
      }
    }

    return (
      <DayPickerInput
        placeholder={format}
        format={format}
        value={value || ''}
        onDayChange={day => {
          changeDate({ path, day: formatDate(day, format) })
        }}
        dayPickerProps={{ disabledDays }}
        inputProps={{
          onClear: () => {
            clearDate({ path })
          }
        }}
        component={Input}
      />
    )
  }
)

export default Picker



// WEBPACK FOOTER //
// ./src/components/Node/Calendar/picker.js